const TYPES = ['中国公民身份证', '护照', '港澳居民往来内地通行证（回乡证）', '港澳居民往来大陆通行证（台胞证）'];
export default TYPES.map(item => ({
  label: item,
  value: item
}));
